export default () => (
  <svg width='6' height='8' viewBox='0 0 6 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5.27337 0.94L4.33337 0L0.333374 4L4.33337 8L5.27337 7.06L2.22004 4L5.27337 0.94Z' fill='none' />
  </svg>

)
